// Logo kit (Addendum 137, 2026-10-30): the header lockup
// is the OWNER'S OWN logo, from the final logo kit his
// designer delivered (~/workspace/sae-logo-kit/, from
// sae-studio-logo-kit.zip) — used VERBATIM, the owner's
// standing ruling for all three Studios: "Why don't you
// use what I provided; you will mess it up if you rebuild
// it." The kit carries a light and a dark lockup SVG; both
// are placed here and switched by the resolved scheme on
// <html data-theme>, the app's one theme mechanism
// (styles.css). Byte identity is pinned in parity.test.tsx:
//   light  sha256 22ce80eed16a9c75d9b9852f6945fa599e585
//          cfdff7fff0b1c336cae33810a9d
//   dark   sha256 3c41e305b25b4f7848376ea2d6543bf15aa8f9
//          67b214de8121b1224d6c8a0e5f
// The two files were diffed before use: they differ ONLY
// in the "SAE" wordmark path's fill/stroke pair (#121216
// light → #FFFFFF dark) and the ™ fill (#8A8A93 →
// #A0A0AA) — same geometry, same badge, same orange
// (#EE7300, the designer's orange). The dark file
// genuinely carries the white wordmark. Both files are
// transparent-ground, so each sits directly on the head
// surface in its scheme.
//
// This lockup supersedes the Addendum 125 in-house grid
// mark (which superseded the parity phase's VW-314-family
// lockup): the inline JSX SVG, the mk-ink / mk-acc-cell
// rules, and the typed "SAE Studio" spans are deleted.
// The designer's badge — the same grid-of-areas idea on
// an ink tile — now also serves as the tab/app icon set
// (index.html, Addendum 137).
//
// Accessible name: the wrapper announces "SAE Studio" as
// one image; the <img> pieces are aria-hidden inside it.
// The lockup sits inline inside the shell title's <h1>,
// ahead of the project name. The license dialog's
// .dialog-brand .wordmark is untouched: every rule lives
// in styles.css under .shell-head .wordmark-lockup ONLY.

import logoDarkUrl from "../assets/sae-studio-logo-dark.svg";
import logoLightUrl from "../assets/sae-studio-logo-light.svg";

export function Wordmark() {
  return (
    <span
      className="wordmark-lockup"
      role="img"
      aria-label="SAE Studio"
      data-testid="wordmark-lockup"
    >
      <img
        className="wordmark-logo wordmark-logo-light"
        src={logoLightUrl}
        alt=""
        aria-hidden="true"
      />
      <img
        className="wordmark-logo wordmark-logo-dark"
        src={logoDarkUrl}
        alt=""
        aria-hidden="true"
      />
    </span>
  );
}
